import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Geo Smyrniotis',
    description: 'Geo Smyrniotis is a cinematographer, director and editor based in Athens, Greece, making commercials, fashion films and music videos for brands like Cosmos Sport, Public, Sneaker10 and Kessaris.',
    url: getOrigin(),
    ogImage: 'https://geo-smyrniotis.cdn.modulify.website/works/cosmos-tvc-2024.jpg',
    email: 'geo.smyrniotis@gmail.com',
    location: 'Athens, Greece',
    links: {
        instagram: 'https://www.instagram.com/geo.smyrniotis/',
        vimeo: 'https://vimeo.com/geosmyrniotis'
    }
}

export const HERO_WORK_SLUG = 'cosmos-tvc-2024'

export const NAV_LINKS = [
    { href: '/works', label: 'Work' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]

export const SERVICES = [
    {
        id: 'cinematography',
        name: 'Cinematography',
        description: 'Lighting, lensing and camera movement designed around the story, from steadicam nights in the city to macro product work in the studio.'
    },
    {
        id: 'directing',
        name: 'Directing',
        description: 'Treatments, shot lists and on-set direction that turn a brief into a film people want to watch to the end, not skip.'
    },
    {
        id: 'editing',
        name: 'Editing',
        description: 'Story-first cuts with pace and intent, delivered for every format a campaign lives in, from the 30-second spot to the vertical cut.'
    },
    {
        id: 'creative-direction',
        name: 'Creative direction',
        description: 'Concept, references and a visual language shaped with the brand, so every frame works toward the same idea and the same result.'
    },
    {
        id: 'sound-design',
        name: 'Sound design',
        description: 'Atmospheres, effects and mix decisions that give the picture its weight, its rhythm and its last word.'
    }
]

export const PROJECT_TYPES = [
    'Commercial',
    'Fashion film',
    'Music video',
    'Brand film',
    'Something else'
]

export const CLIENTS = [
    'Adidas',
    'BBDO',
    'Cosmos Sport',
    'Funky Buddha',
    'JD Sports',
    'Kessaris',
    'Klarna',
    'New Era',
    'Odysseyten',
    'Public',
    'Red Bull',
    'Serkos',
    'Slam Dunk',
    'Sneaker10',
    'Zolotas'
]

export const TOOLKIT = [
    {
        name: 'DaVinci Resolve Studio',
        use: 'Editing and colour'
    },
    {
        name: 'Adobe After Effects',
        use: 'Motion and finishing'
    },
    {
        name: 'Adobe Photoshop',
        use: 'Stills, frames and boards'
    }
]
